import { Circle as IconOther } from 'react-feather';
import loadIcon from './loadIcon';

const { iconsByClass, iconsByType, importPathsByType } = require('./icons');

// In-memory dictionary of lazy-loaded icon components.
const iconCache: any = {};

const iconFail = (path: string) => (error: string) => {
  console.error(`Unable to load icon "${path}"`, error);
  iconCache[path] = IconOther;
  return iconCache[path];
};

const iconPass = (path: string) => (component: any) => {
  iconCache[path] = component.default;
  return iconCache[path];
};

function load(typePath: string) {
  const m = typePath.match('^([^//]+)/(.+)');

  if (!m) {
    console.error(`Invalid icon type/path: ${typePath}`);
    return IconOther;
  }

  const [path, type, name] = m;

  if (type && iconCache[path]) {
    return iconCache[path];
  }

  // Check that the icon type is valid (e.g. aws or feather)
  if (!importPathsByType[type]) {
    return IconOther;
  }

  return loadIcon(type, name).then(iconPass(path)).catch(iconFail(path));
}

const getUnloadedPaths = (paths: string[]): string[] => {
  return paths.filter((path) => iconCache[path] === undefined);
};

const filterByUnique = (val: any, idx: number, list: any[]) =>
  val && list.indexOf(val) === idx;
const get = (path: string) => iconCache[path] || IconOther;

const DEFAULT_ICON = 'feather/circle';

const classToPath = (entityClass: string | string[] | null | undefined) => {
  if (!entityClass) {
    return DEFAULT_ICON;
  }

  const iconClass = Array.isArray(entityClass) ? entityClass[0] : entityClass;
  return iconsByClass[iconClass] || DEFAULT_ICON;
};

const typeToPath = (_type: any) => {
  const type = typeof _type === 'object' ? _type[0] : _type;
  return iconsByType[type] || DEFAULT_ICON;
};

function entityToPath(entity: any) {
  let iconPath = typeToPath(entity._type);

  if (iconPath === DEFAULT_ICON) {
    iconPath = classToPath(entity._class);
  }

  return iconPath;
}

// Exposed in the lib as `icon`
export default {
  classToPath,
  entityToPath,
  filterByUnique,
  get,
  getUnloadedPaths,
  load,
  typeToPath,
};
